var _radialGradient, _path, _linearGradient, _path2, _path3, _linearGradient2, _path4, _linearGradient3, _path5, _radialGradient2, _path6, _radialGradient3, _path7, _radialGradient4, _path8, _linearGradient4, _path9, _path10, _radialGradient5, _path11, _radialGradient6, _path12, _linearGradient5, _path13, _path14, _path15, _linearGradient6, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostcontestdiscussionscb90296E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "t3Hn0Pw2mzVrOjs6GPr17a",
    cx: 34.846,
    cy: -586.518,
    r: 8.535,
    gradientTransform: "matrix(1 0 0 -1 0 -562)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#261103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#431d06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662c09"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t3Hn0Pw2mzVrOjs6GPr17a)",
    d: "M35,16.795c-6.41,0-8,10.351-8,10.351c0,1.843,0.856,3.457,2.648,3.885 c1.535,0.367,3.466,0.706,5.352,0.706s3.817-0.34,5.352-0.706C42.144,30.603,43,28.988,43,27.146C43,27.146,41.41,16.795,35,16.795z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t3Hn0Pw2mzVrOjs6GPr17b",
    x1: 10.729,
    x2: 13.792,
    y1: 31.213,
    y2: 41.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a85d9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t3Hn0Pw2mzVrOjs6GPr17b)",
    d: "M13,31.571c-6.075,0-11,3.579-11,7.268v0.786C2,40.384,2.616,41,3.375,41H24v-2.161 C24,35.151,19.075,31.571,13,31.571z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6a121",
    d: "M16,33.6c0,1.138-1.2,2.4-3,2.4s-3-1.262-3-2.4c0-1.582,0-4.221,0-4.221h6 C16,29.379,16,32.018,16,33.6z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t3Hn0Pw2mzVrOjs6GPr17c",
    x1: 18.548,
    x2: 19.771,
    y1: 25.5,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c48f0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#d19b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#dca51f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0a922"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t3Hn0Pw2mzVrOjs6GPr17c)",
    d: "M18.944,24h-0.88v3h0.997c0.343,0,0.636-0.234,0.694-0.555l0.23-1.277 C20.094,24.557,19.598,24,18.944,24z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t3Hn0Pw2mzVrOjs6GPr17d",
    x1: -1045.941,
    x2: -1044.718,
    y1: 25.5,
    y2: 25.5,
    gradientTransform: "matrix(-1 0 0 1 -1038.49 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c48f0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#d19b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#dca51f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0a922"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t3Hn0Pw2mzVrOjs6GPr17d)",
    d: "M7.056,24h0.88v3H6.939c-0.343,0-0.636-0.234-0.694-0.555l-0.23-1.277 C5.906,24.557,6.402,24,7.056,24z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "t3Hn0Pw2mzVrOjs6GPr17e",
    cx: 24.339,
    cy: 62.681,
    r: 7.503,
    gradientTransform: "matrix(.92 0 0 .92 -9.391 -33.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t3Hn0Pw2mzVrOjs6GPr17e)",
    d: "M13,16.6c-2.961,0-6,0.45-6,6.85c0,0.512,0,2.918,0,3.465C7,29.2,10.6,32,13,32s6-2.8,6-5.085 c0-0.547,0-2.953,0-3.465C19,17.05,15.961,16.6,13,16.6z"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "t3Hn0Pw2mzVrOjs6GPr17f",
    cx: 10.717,
    cy: 85.499,
    r: 21.807,
    gradientTransform: "translate(-2.025 -56.25) scale(.8433)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t3Hn0Pw2mzVrOjs6GPr17f)",
    d: "M13,15c-2.752,0-3,1-3,1c-1.647,0-4,1.73-4,5c0,1.192,0.176,2.529,1,5 c0.393-4.717,1.444-6.706,2.706-6.706c0.913,0,1.329,0.824,3.294,0.824c1.659,0,1.647-0.824,3.294-0.824 C18.456,19.294,19,25.256,19,26c0.824-2.471,1-3.959,1-5C20,17.702,17.474,15,13,15z"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "t3Hn0Pw2mzVrOjs6GPr17g",
    cx: 20.594,
    cy: 16.681,
    r: 22.991,
    gradientTransform: "matrix(.8198 0 0 1.0222 -4.726 .757)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t3Hn0Pw2mzVrOjs6GPr17g)",
    d: "M13.04,15c-2.91,0-3.248,1.905-3.248,1.905c-0.029,0.966,0,1.905,0,1.905S10.291,20,13.324,20 c1.831,0,4.456-1.362,4.456-5C17.779,15,17.19,15,13.04,15z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t3Hn0Pw2mzVrOjs6GPr17h",
    x1: 32.574,
    x2: 35.558,
    y1: 31.269,
    y2: 41.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a85d9"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t3Hn0Pw2mzVrOjs6GPr17h)",
    d: "M35,31.571c-6.075,0-11,3.579-11,7.268V41h20.625C45.384,41,46,40.384,46,39.625v-0.786 C46,35.151,41.075,31.571,35,31.571z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6a121",
    d: "M38,33.6c0,1.138-1.2,2.4-3,2.4s-3-1.262-3-2.4c0-1.582,0-4.221,0-4.221h6 C38,29.379,38,32.018,38,33.6z"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "t3Hn0Pw2mzVrOjs6GPr17i",
    cx: 48.253,
    cy: 62.445,
    r: 7.197,
    gradientTransform: "matrix(.92 0 0 .92 -9.391 -33.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t3Hn0Pw2mzVrOjs6GPr17i)",
    d: "M35,16.167c-2.467,0-5,0.375-5,5.708c0,0.427,0,5.432,0,5.888C30,29.667,33,32,35,32 s5-2.333,5-4.237c0-0.456,0-5.461,0-5.888C40,16.542,37.467,16.167,35,16.167z"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "t3Hn0Pw2mzVrOjs6GPr17j",
    cx: 30.147,
    cy: -576.339,
    r: 22.694,
    gradientTransform: "matrix(.9023 0 0 -.9023 3.421 -505.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t3Hn0Pw2mzVrOjs6GPr17j)",
    d: "M35,14c-3.302,0-3.636,2.182-3.636,2.182C30.021,16.38,27,16.332,27,27.091 c0,2.569,1.173,3.364,1.986,3.7c-2.232-8.396,4.108-7.405,3.105-13.155c2.575,7.517,11.315,2.428,8.923,13.155 c1.248-0.528,1.986-2.111,1.986-3.7C43,18.305,39.708,14,35,14z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t3Hn0Pw2mzVrOjs6GPr17k",
    x1: 30.088,
    x2: 39.941,
    y1: -565.937,
    y2: -579.683,
    gradientTransform: "matrix(1 0 0 -1 0 -562)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#037478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006063"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t3Hn0Pw2mzVrOjs6GPr17k)",
    d: "M23,4h20c0.552,0,1,0.448,1,1v10.398c0,0.495-0.656,0.67-0.903,0.242L41,12H23 c-0.552,0-1-0.448-1-1V5C22,4.448,22.448,4,23,4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25,11h-3V4h5v5C27,10.105,26.105,11,25,11z",
    opacity: 0.05
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25,10.5h-3V4h4.5v5C26.5,9.828,25.828,10.5,25,10.5z",
    opacity: 0.07
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t3Hn0Pw2mzVrOjs6GPr17l",
    x1: 11.865,
    x2: 18.975,
    y1: -564.337,
    y2: -577.49,
    gradientTransform: "matrix(1 0 0 -1 0 -562)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20afb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16979d"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t3Hn0Pw2mzVrOjs6GPr17l)",
    d: "M25,2H5C4.448,2,4,2.448,4,3v10.398c0,0.495,0.656,0.67,0.903,0.242L7,10h18 c0.552,0,1-0.448,1-1V3C26,2.448,25.552,2,25,2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostcontestdiscussionscb90296E);
export default __webpack_public_path__ + "static/media/post contest discussions.cb90296e.46391519bb9c0baccdc9fb2ac4405636.svg";
export { ForwardRef as ReactComponent };